import React from 'react'

function FaqList({ homeData, faqs, faqTitle }) {
  const list =
    Array.isArray(faqs) && faqs.length > 0
      ? faqs
      : homeData?.faq || [];

  if (!list || list.length === 0) {
    return null;
  }

  const heading = faqTitle || "Frequently Asked Questions";

  return (
    <>
      <div className="site-width">
        <div className="pagehd text-center mb-4">
          <h2>{heading}</h2>
        </div>
        <div className="faqsCards">
          <div className="accordion" id="accordionFaqList">
            {list.map((item, index) => (
              <div className="accordion-item" key={index}>
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse_faq_${index}`}
                    aria-expanded={index === 0 ? "true" : "false"}
                    aria-controls={`collapse_faq_${index}`}
                  >
                    {item.question}
                  </button>
                </h2>
                <div
                  id={`collapse_faq_${index}`}
                  className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                  data-bs-parent="#accordionFaqList"
                >
                  <div className="accordion-body">
                    {typeof item.answer === 'string' &&
                    (item.answer.includes('<p>') ||
                      item.answer.includes('<br') ||
                      item.answer.includes('<div>') ||
                      item.answer.includes('<ul>')) ? (
                      <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                    ) : (
                      <p style={{ whiteSpace: "pre-line", margin: 0 }}>
                        {item.answer}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default FaqList

